import angular from 'angular';
import '../layouts.module';
import template from './auth-layout.component.html';
import './auth-layout.component.scss';

angular.module('app.layouts').component('cpAuthLayout', { template });
